export function padArrayToMultipleOfN<T>(
  array: T[],
  n: number,
): (T | undefined)[] {
  const lengthToAdd = (n - (array.length % n)) % n;

  return [...array, ...Array(lengthToAdd).fill(undefined)];
}
